import { ComponentPropsWithoutRef, FC } from 'react';

type CheckIconProps = ComponentPropsWithoutRef<'svg'>;

export const CheckIcon: FC<CheckIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            {...props}
        >
            <path
                d="M3.246 7.65783L0.147461 4.53846L0.835732 3.85017L3.246 6.2436L9.16827 0.342167L9.85254 1.05127L3.246 7.65783Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
